import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline_tab" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex column\"><label for=\"name\">Your Name</label><input class=\"w-50\" type=\"text\" id=\"name\" name=\"from_name\" required></div><div class=\"flex column\"><label for=\"email\">Your Email Address</label><input class=\"w-50\" type=\"email\" id=\"email\" name=\"from_email\" required></div><div class=\"flex column m-b-1\"><label for=\"message\">Your Message</label><textarea name=\"message\" id=\"message\" cols=\"30\" rows=\"10\"></textarea></div><button class=\"btn-action w-quarter text-align-c\" type=\"submit\">Send</button>", 4)
const _hoisted_6 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["light-text", _ctx.$style.emailFormContainer])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.$style.emailFormHeader)
      }, "Contact Me", 2)
    ]),
    _createElementVNode("form", {
      id: "contact-form",
      class: _normalizeClass(_ctx.$style.emailForm),
      onSubmit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendEmail($event)))
    }, _hoisted_6, 34)
  ], 2))
}